export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    base_to_fs_start: [
      0,
      15630.136054421768,
    ],
    big_win: [
      17000,
      3715.4195011337874,
    ],
    button_spin: [
      22000,
      463.3560090702957,
    ],
    free_bet_big_win: [
      24000,
      1362.3129251700695,
    ],
    free_bet_mega_win: [
      27000,
      2207.913832199548,
    ],
    free_bet_total_win: [
      31000,
      973.3560090702938,
    ],
    free_bet_ultra_win: [
      33000,
      1297.414965986391,
    ],
    free_spin_ambient: [
      36000,
      29738.526077097504,
    ],
    free_spin_music: [
      67000,
      49663.21995464853,
    ],
    free_spin_popup: [
      118000,
      1660.9523809523807,
    ],
    free_spin_start: [
      121000,
      3537.9818594104363,
    ],
    fs_end_to_base: [
      126000,
      3271.7913832199483,
    ],
    fs_game_to_fs_end: [
      131000,
      2074.2857142857074,
    ],
    fs_start_to_fs_game: [
      135000,
      3256.938775510207,
    ],
    inside_buttons: [
      140000,
      312.6984126984098,
    ],
    main_ambient: [
      142000,
      46438.52607709749,
    ],
    main_music: [
      190000,
      127139.07029478457,
    ],
    mega_win: [
      319000,
      3567.9591836734517,
    ],
    outside_buttons: [
      324000,
      724.3764172335432,
    ],
    reel_spin: [
      326000,
      2198.4580498865967,
    ],
    reel_stop_01: [
      330000,
      167.32426303855163,
    ],
    reel_stop_02: [
      332000,
      143.42403628120337,
    ],
    reel_stop_03: [
      334000,
      136.68934240365616,
    ],
    reel_stop_04: [
      336000,
      171.17913832197473,
    ],
    reel_stop_05: [
      338000,
      151.74603174602908,
    ],
    regular_win: [
      340000,
      1279.1156462585036,
    ],
    scatter_chance: [
      343000,
      4203.129251700659,
    ],
    scatter_wild_stop: [
      349000,
      1741.859410430834,
    ],
    symbol_stop: [
      352000,
      449.6371882086123,
    ],
    tap_to_play: [
      354000,
      3676.6439909297333,
    ],
    ultra_win: [
      359000,
      3017.029478458028,
    ],
  },
}
